import { BaseProducerRevenueReportViewStore } from "common/stores/producer";

class ProducerRevenueReportViewStore extends BaseProducerRevenueReportViewStore {
    producerId = null;

    constructor(rootStore, { routeStore }) {
        super(rootStore, { maskUserNames: true });
        this.routeStore = routeStore;
        this.producerId = this.rootStore.routerStore.routerState.params.id;
    }

    find(params) {
        this.abortExistingRequest();
        this._abortController = new AbortController();
        params.producerId = this.producerId;
        if (this.selectedReportViewId === 0) {
            return this.routeStore.findProducerReportItems(params, this._abortController);
        } else if (this.selectedReportViewId === 1) {
            return this.routeStore.findProducerReportContentItems(params, this._abortController);
        } else if (this.selectedReportViewId === 2) {
            return this.routeStore.findProducerReportTrackItems(params, this._abortController);
        }
    }

    getSumaryData(params) {
        return this.routeStore.getProducerPaymentSummary(this.producerId, params);
    }

    getProducerReportTrackItemsCsv(filter, producerId) {
        return this.routeStore.getProducerReportTrackItemsCsv(filter, producerId);
    }
}

export default ProducerRevenueReportViewStore;
